"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _kendoReactGrid = require("@progress/kendo-react-grid");

var _kendoDataQuery = require("@progress/kendo-data-query");

var _kendoReactExcelExport = require("@progress/kendo-react-excel-export");

var _kendoReactPdf = require("@progress/kendo-react-pdf");

var _kendoReactIntl = require("@progress/kendo-react-intl");

var _likelySubtags = _interopRequireDefault(require("cldr-core/supplemental/likelySubtags.json"));

var _currencyData = _interopRequireDefault(require("cldr-core/supplemental/currencyData.json"));

var _weekData = _interopRequireDefault(require("cldr-core/supplemental/weekData.json"));

var _numbers = _interopRequireDefault(require("cldr-numbers-full/main/pl/numbers.json"));

var _currencies = _interopRequireDefault(require("cldr-numbers-full/main/pl/currencies.json"));

var _caGregorian = _interopRequireDefault(require("cldr-dates-full/main/pl/ca-gregorian.json"));

var _dateFields = _interopRequireDefault(require("cldr-dates-full/main/pl/dateFields.json"));

var _timeZoneNames = _interopRequireDefault(require("cldr-dates-full/main/pl/timeZoneNames.json"));

var _FoxButton = _interopRequireDefault(require("fox-react/dist/components/FoxButton"));

var _foxGridFilterOperators = _interopRequireDefault(require("./foxGridFilterOperators"));

var _FoxGridColumn = _interopRequireDefault(require("./FoxGridColumn"));

var _FoxGridColumnMenu = _interopRequireDefault(require("./FoxGridColumnMenu"));

var _pl = _interopRequireDefault(require("./pl.json"));

var _utils = require("./utils");

var _visualFunctions = require("./visualFunctions");

var _gridConfigurationFunctions = require("./gridConfigurationFunctions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/* eslint-disable react/no-unused-state */


(0, _kendoReactIntl.load)(_likelySubtags.default, _currencyData.default, _weekData.default, _numbers.default, _currencies.default, _caGregorian.default, _dateFields.default, _timeZoneNames.default);
(0, _kendoReactIntl.loadMessages)(_pl.default, 'pl-PL');
var propTypes = {
  isSortable: _propTypes.default.bool,
  isFilterable: _propTypes.default.bool,
  isPageable: _propTypes.default.bool,
  isGroupable: _propTypes.default.bool,
  isReorderable: _propTypes.default.bool,
  isResizable: _propTypes.default.bool,
  onDataStateChange: _propTypes.default.func.isRequired,
  results: _propTypes.default.shape({
    items: _propTypes.default.any.isRequired,
    totalCount: _propTypes.default.number.isRequired
  }).isRequired,
  children: _propTypes.default.any.isRequired,
  dataState: _propTypes.default.object.isRequired,
  pagerConfig: _propTypes.default.shape({
    type: _propTypes.default.oneOf(['numeric', 'input']),
    buttonCount: _propTypes.default.number,
    info: _propTypes.default.bool,
    pageSizes: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.array]),
    previousNext: _propTypes.default.bool
  }),
  sortConfig: _propTypes.default.shape({
    allowUnsort: _propTypes.default.bool,
    mode: _propTypes.default.oneOf(['single', 'multiple'])
  }),
  onGroupChange: _propTypes.default.func.isRequired,
  loadOnStart: _propTypes.default.bool,
  onLoadData: _propTypes.default.func.isRequired,
  debounceLoadTime: _propTypes.default.number,
  defaultSortField: _propTypes.default.string,
  defaultSortDir: _propTypes.default.oneOf(['asc', 'desc']),
  onSetDefaultSort: _propTypes.default.func.isRequired,
  hasColumnMenu: _propTypes.default.bool,
  onResetFilters: _propTypes.default.func.isRequired,
  exportToExcelEnable: _propTypes.default.bool,
  customExcelItems: _propTypes.default.any,
  customExcelColumns: _propTypes.default.any,
  exportToPdfEnable: _propTypes.default.bool,
  customPdfItems: _propTypes.default.any,
  excelFileName: _propTypes.default.string,
  pdfFileName: _propTypes.default.string,
  renderButtons: _propTypes.default.node,
  renderRightButtons: _propTypes.default.node,
  onColumnReorder: _propTypes.default.func,
  columnsInfo: _propTypes.default.array,
  onColumnsSubmit: _propTypes.default.func,
  onColumnResize: _propTypes.default.func
};
var defaultProps = {
  isSortable: true,
  isFilterable: true,
  isPageable: true,
  isGroupable: true,
  isReorderable: true,
  isResizable: true,
  pagerConfig: {
    type: 'numeric',
    buttonCount: 5,
    info: true,
    pageSizes: [5, 10, 20, 50, 100, 200, 99999],
    previousNext: true
  },
  sortConfig: {
    allowUnsort: false,
    mode: 'single'
  },
  loadOnStart: true,
  debounceLoadTime: 300,
  defaultSortField: undefined,
  defaultSortDir: 'asc',
  hasColumnMenu: true,
  exportToExcelEnable: true,
  customExcelItems: undefined,
  customExcelColumns: undefined,
  exportToPdfEnable: false,
  customPdfItems: undefined,
  excelFileName: 'export.xlsx',
  pdfFileName: 'export.pdf',
  renderButtons: undefined,
  renderRightButtons: undefined,
  onColumnReorder: function onColumnReorder() {},
  columnsInfo: [],
  onColumnsSubmit: function onColumnsSubmit() {},
  onColumnResize: function onColumnResize() {}
};

var FoxGrid =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FoxGrid, _PureComponent);

  function FoxGrid(props) {
    var _this;

    _classCallCheck(this, FoxGrid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FoxGrid).call(this, props));
    _this.state = {
      loadingCount: 0,
      columns: _this.props.children,
      filterButtonOffset: 0,
      exportingToPdf: false
    };
    _this.dataStateChange = _this.dataStateChange.bind(_assertThisInitialized(_this));
    _this.getItems = _this.getItems.bind(_assertThisInitialized(_this));
    _this.onGroupChange = _this.onGroupChange.bind(_assertThisInitialized(_this));
    _this.columnsSubmit = _gridConfigurationFunctions.columnsSubmit.bind(_assertThisInitialized(_this));
    _this.setColumnWidth = _visualFunctions.setColumnWidth.bind(_assertThisInitialized(_this));
    _this.getColumnHeaderHeight = _visualFunctions.getColumnHeaderHeight.bind(_assertThisInitialized(_this));
    _this.resetFilters = _this.resetFilters.bind(_assertThisInitialized(_this));
    _this.exportToExcel = _this.exportToExcel.bind(_assertThisInitialized(_this));
    _this.exportToPdf = _this.exportToPdf.bind(_assertThisInitialized(_this));
    _this.pdfExportDone = _this.pdfExportDone.bind(_assertThisInitialized(_this));
    _this.getFilterResetVerticalOffset = _visualFunctions.getFilterResetVerticalOffset.bind(_assertThisInitialized(_this));
    _this.columnReorder = _gridConfigurationFunctions.columnReorder.bind(_assertThisInitialized(_this));
    _this.applayColumnInfo = _gridConfigurationFunctions.applayColumnInfo.bind(_assertThisInitialized(_this));
    _this.columnsSubmit = _gridConfigurationFunctions.columnsSubmit.bind(_assertThisInitialized(_this));
    _this.columResize = _gridConfigurationFunctions.columResize.bind(_assertThisInitialized(_this));
    _this.loadData = (0, _debounce.default)(_this.loadData.bind(_assertThisInitialized(_this)), _this.props.debounceLoadTime);
    _this.wrappedGridRef = null;
    _this.gridRef = undefined;
    _this.gridExcelExportRef = undefined;
    _this.gridPdfExportRef = undefined;
    return _this;
  }

  _createClass(FoxGrid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          loadOnStart = _this$props.loadOnStart,
          dataState = _this$props.dataState,
          onDataStateChange = _this$props.onDataStateChange,
          defaultSortField = _this$props.defaultSortField,
          defaultSortDir = _this$props.defaultSortDir,
          onSetDefaultSort = _this$props.onSetDefaultSort;

      var newDataState = _objectSpread({}, dataState);

      if (defaultSortField && !dataState.sort.length) {
        var sort = {
          field: defaultSortField,
          dir: defaultSortDir
        };
        onSetDefaultSort(sort);
        newDataState = (0, _utils.setNewSort)(dataState, sort);
      }

      loadOnStart && onDataStateChange(newDataState) && this.loadData(newDataState);
      this.setColumnWidth(this.wrappedGridRef);
      this.getFilterResetVerticalOffset();
      (0, _visualFunctions.scrollPageToGrid)();
      this.setState(function (prev) {
        return {
          columns: _this2.applayColumnInfo(prev.columns)
        };
      });
      (0, _visualFunctions.addMissingTitleAttributes)();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.getFilterResetVerticalOffset();
    }
  }, {
    key: "onGroupChange",
    value: function onGroupChange(event) {
      this.props.onGroupChange(event.group);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var _this$props2 = this.props,
          results = _this$props2.results,
          dataState = _this$props2.dataState;

      if (!dataState.group) {
        return results.items;
      }

      var result = (0, _kendoDataQuery.groupBy)(results.items, dataState.group);
      return result;
    }
  }, {
    key: "loadData",
    value: function loadData(dataState) {
      var _this3 = this;

      this.setState(function (state) {
        return {
          loadingCount: state.loadingCount + 1
        };
      });
      this.props.onLoadData(dataState).finally(function () {
        _this3.setState(function (state) {
          return {
            loadingCount: state.loadingCount - 1
          };
        });
      });
    }
  }, {
    key: "dataStateChange",
    value: function dataStateChange(event) {
      this.props.onDataStateChange(event.data);
      this.loadData(event.data);
    }
  }, {
    key: "resetFilters",
    value: function resetFilters() {
      var _this4 = this;

      this.props.onResetFilters().then(function () {
        return _this4.loadData(_this4.props.dataState);
      });
    }
  }, {
    key: "exportToExcel",
    value: function exportToExcel() {
      var _this$props3 = this.props,
          customExcelItems = _this$props3.customExcelItems,
          customExcelColumns = _this$props3.customExcelColumns;
      var items = customExcelItems || this.getItems();
      var columns = customExcelColumns || this.gridRef.columns;
      this.gridExcelExportRef.save(items, columns);
    }
  }, {
    key: "exportToPdf",
    value: function exportToPdf() {
      var customPdfItems = this.props.customPdfItems;
      var items = customPdfItems || this.getItems();
      this.gridPdfExportRef.save(items, this.pdfExportDone);
      this.setState({
        exportingToPdf: true
      });
    }
  }, {
    key: "pdfExportDone",
    value: function pdfExportDone() {
      this.setState({
        exportingToPdf: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props4 = this.props,
          isSortable = _this$props4.isSortable,
          isFilterable = _this$props4.isFilterable,
          isPageable = _this$props4.isPageable,
          isGroupable = _this$props4.isGroupable,
          isReorderable = _this$props4.isReorderable,
          isResizable = _this$props4.isResizable,
          results = _this$props4.results,
          dataState = _this$props4.dataState,
          pagerConfig = _this$props4.pagerConfig,
          sortConfig = _this$props4.sortConfig,
          hasColumnMenu = _this$props4.hasColumnMenu,
          exportToExcelEnable = _this$props4.exportToExcelEnable,
          exportToPdfEnable = _this$props4.exportToPdfEnable,
          excelFileName = _this$props4.excelFileName,
          pdfFileName = _this$props4.pdfFileName;

      var grid = _react.default.createElement(_kendoReactGrid.Grid, {
        className: !!this.state.loadingCount && 'fox_spinner',
        filterOperators: _foxGridFilterOperators.default,
        sortable: isSortable && sortConfig,
        filterable: isFilterable,
        pageable: isPageable && pagerConfig,
        groupable: isGroupable,
        reorderable: isReorderable,
        resizable: isResizable,
        data: this.getItems(),
        total: results.totalCount,
        filter: dataState.filter,
        group: dataState.group,
        skip: dataState.skip,
        take: dataState.take,
        sort: dataState.sort,
        onDataStateChange: this.dataStateChange,
        onGroupChange: this.onGroupChange,
        onColumnReorder: this.columnReorder,
        onColumnResize: this.columResize,
        ref: function ref(gridRef) {
          _this5.gridRef = gridRef;
        }
      }, _react.default.createElement(_kendoReactGrid.GridToolbar, null, this.props.renderButtons, exportToExcelEnable && _react.default.createElement(_FoxButton.default, {
        onClick: this.exportToExcel
      }, "Export to Excel"), exportToPdfEnable && _react.default.createElement(_FoxButton.default, {
        onClick: this.exportToPdf
      }, "Export to PDF"), this.props.renderRightButtons), !hasColumnMenu ? this.state.columns : this.state.columns.map(function (column) {
        return !column.props.hidden && _react.default.createElement(_FoxGridColumn.default, _extends({
          key: column.props.field,
          columnMenu: function columnMenu(props) {
            return _react.default.createElement(_FoxGridColumnMenu.default, _extends({}, props, {
              columns: _this5.state.columns,
              onColumnsSubmit: _this5.columnsSubmit
            }));
          }
        }, column.props));
      }));

      var wrappedGrid = _react.default.createElement("div", {
        className: "grid_container",
        ref: function ref(wrappedGridRef) {
          _this5.wrappedGridRef = wrappedGridRef;
        }
      }, _react.default.createElement(_FoxButton.default, {
        onClick: this.resetFilters,
        icon: "filter-clear",
        primary: true,
        disabled: !dataState.filter || !!this.state.loadingCount,
        className: "fox-clear-button",
        title: _pl.default.grid.filterClearButton,
        style: {
          top: "".concat(this.state.filterButtonOffset, "px")
        }
      }), _react.default.createElement(_kendoReactIntl.LocalizationProvider, {
        language: "pl-PL"
      }, _react.default.createElement(_kendoReactIntl.IntlProvider, {
        locale: "pl"
      }, grid)));

      return _react.default.createElement(_react.default.Fragment, null, wrappedGrid, exportToExcelEnable && _react.default.createElement(_kendoReactExcelExport.ExcelExport, {
        ref: function ref(excelExporter) {
          _this5.gridExcelExportRef = excelExporter;
        },
        fileName: excelFileName
      }), exportToPdfEnable && _react.default.createElement(_kendoReactPdf.GridPDFExport, {
        ref: function ref(pdfExporter) {
          _this5.gridPdfExportRef = pdfExporter;
        },
        fileName: pdfFileName,
        margin: "1cm",
        paperSize: "A4"
      }, grid));
    }
  }]);

  return FoxGrid;
}(_react.PureComponent);

FoxGrid.propTypes = propTypes;
FoxGrid.defaultProps = defaultProps;
var _default = FoxGrid;
exports.default = _default;